import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {Col, Row, Tooltip} from "reactstrap";
import classnames from "classnames";
import ColorPickerModal from "../../../../components/ColorPickerModal";

const KEY_BG = '$survey-nextStatement-bgColor';
const KEY_BG_ACTIVE = '$survey-nextStatement-bgColor-active';
const KEY_COLOR = '$survey-nextStatement-color';
const KEY_COLOR_ACTIVE = '$survey-nextStatement-color-active';

class NextStatement extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      values: {
        [KEY_BG]: props.ownStyles[KEY_BG] ? props.ownStyles[KEY_BG] : false,
        [KEY_BG_ACTIVE]: props.ownStyles[KEY_BG_ACTIVE] ? props.ownStyles[KEY_BG_ACTIVE] : false,
        [KEY_COLOR]: props.ownStyles[KEY_COLOR] ? props.ownStyles[KEY_COLOR] : false,
        [KEY_COLOR_ACTIVE]: props.ownStyles[KEY_COLOR_ACTIVE] ? props.ownStyles[KEY_COLOR_ACTIVE] : false,
      },
      modalOpen: {
        bg: false,
        bgActive: false,
        color: false,
        colorActive: false,
      },
      tooltip: {
        bg: false,
        bgActive: false,
        color: false,
        colorActive: false,
      }
    };

    this.getDefaultValue = this.getDefaultValue.bind(this);
    this.toggleTooltip = this.toggleTooltip.bind(this);
  }

  toggleTooltip(key){
    this.setState({
      tooltip: {
        ...this.state.tooltip,
        [key]: !this.state.tooltip[key]
      }
    })
  }

  getDefaultValue(key){
    return this.props.ownStylesDefault[key];
  }

  clearValues(){
    this.setState({
      values: {
        [KEY_BG]: '',
        [KEY_BG_ACTIVE]: '',
        [KEY_COLOR]: '',
        [KEY_COLOR_ACTIVE]: '',
      }
    });

    this.props.handlerUpdate({[KEY_BG]: ''});
    this.props.handlerUpdate({[KEY_BG_ACTIVE]: ''});
    this.props.handlerUpdate({[KEY_COLOR]: ''});
    this.props.handlerUpdate({[KEY_COLOR_ACTIVE]: ''});
  }

  updateValue(key, value){
    this.setState({
      values: {
        ...this.state.values,
        [key]: value
      }

    });

    this.props.handlerUpdate({[key]: value});
  }

  render() {
    const {values, modalOpen} = this.state;
    const inactive =
      [false, ''].indexOf(values[KEY_BG]) >= 0
      && [false, ''].indexOf(values[KEY_BG_ACTIVE]) >= 0
      && [false, ''].indexOf(values[KEY_COLOR]) >= 0
      && [false, ''].indexOf(values[KEY_COLOR_ACTIVE]) >= 0
    ;

    return (
      <Row className={classnames({
        'py-1 px-3 align-items-center': true,
        'inactive': inactive,
      })}>
        <label className="col col-5 mb-0">Przycisk "Następne stwierdzenie" {!inactive && <i className="icon-clear-value fas fa-trash float-right" onClick={() => this.clearValues()} />}</label>
        <Col className="col-7 d-flex">
          <div className="d-flex">
            <div className="d-flex">
              <div id="key-nextStatement-bg" className="mr-2">
                <div className="color-picker-preview" onClick={() => this.setState({modalOpen: {...modalOpen, bg: true}})} style={{
                  backgroundColor: values[KEY_BG] ? values[KEY_BG] : this.getDefaultValue(KEY_BG),
                }} />
                {modalOpen.bg && <ColorPickerModal
                  color={values[KEY_BG] ? values[KEY_BG] : this.getDefaultValue(KEY_BG)}
                  onClose={() => this.setState({modalOpen: false})}
                  onSelect={value => {
                    this.setState({modalOpen: {...modalOpen, bg: false}});
                    this.updateValue(KEY_BG, value);
                  }}
                />}
                <Tooltip
                  delay={0}
                  placement="top"
                  isOpen={this.state.tooltip.bg}
                  target={'key-nextStatement-bg'}
                  toggle={() => this.toggleTooltip('bg')}
                >
                  Kolor tła gdy przycisk jest nieaktywny
                </Tooltip>
              </div>

              <div id="key-nextStatement-color" className="mr-2">
                <div className="color-picker-preview" onClick={() => this.setState({modalOpen: {...modalOpen, color: true}})} style={{
                  backgroundColor: values[KEY_COLOR] ? values[KEY_COLOR] : this.getDefaultValue(KEY_COLOR),
                }} />
                {modalOpen.color && <ColorPickerModal
                  color={values[KEY_COLOR] ? values[KEY_COLOR] : this.getDefaultValue(KEY_COLOR)}
                  onClose={() => this.setState({modalOpen: false})}
                  onSelect={value => {
                    this.setState({modalOpen: {...modalOpen, color: false}});
                    this.updateValue(KEY_COLOR, value);
                  }}
                />}
                <Tooltip
                  delay={0}
                  placement="top"
                  isOpen={this.state.tooltip.color}
                  target={'key-nextStatement-color'}
                  toggle={() => this.toggleTooltip('color')}
                >
                  Kolor tekstu gdy przycisk jest nieaktywny
                </Tooltip>
              </div>
            </div>

            <div className="d-flex ml-5">
              <div id="key-prev-bgActive" className="mr-2">
                <div className="color-picker-preview" onClick={() => this.setState({modalOpen: {...modalOpen, bgActive: true}})} style={{
                  backgroundColor: values[KEY_BG_ACTIVE] ? values[KEY_BG_ACTIVE] : this.getDefaultValue(KEY_BG_ACTIVE),
                }} />
                {modalOpen.bgActive && <ColorPickerModal
                  color={values[KEY_BG_ACTIVE] ? values[KEY_BG_ACTIVE] : this.getDefaultValue(KEY_BG_ACTIVE)}
                  onClose={() => this.setState({modalOpen: false})}
                  onSelect={value => {
                    this.setState({modalOpen: {...modalOpen, bgActive: false}});
                    this.updateValue(KEY_BG_ACTIVE, value);
                  }}
                />}
                <Tooltip
                  delay={0}
                  placement="top"
                  isOpen={this.state.tooltip.bgActive}
                  target={'key-prev-bgActive'}
                  toggle={() => this.toggleTooltip('bgActive')}
                >
                  Kolor tła gdy przycisk jest aktywny
                </Tooltip>
              </div>

              <div id="key-prev-colorActive" className="mr-2">
                <div className="color-picker-preview" onClick={() => this.setState({modalOpen: {...modalOpen, colorActive: true}})} style={{
                  backgroundColor: values[KEY_COLOR_ACTIVE] ? values[KEY_COLOR_ACTIVE] : this.getDefaultValue(KEY_COLOR_ACTIVE),
                }} />
                {modalOpen.colorActive && <ColorPickerModal
                  color={values[KEY_COLOR_ACTIVE] ? values[KEY_COLOR_ACTIVE] : this.getDefaultValue(KEY_COLOR_ACTIVE)}
                  onClose={() => this.setState({modalOpen: false})}
                  onSelect={value => {
                    this.setState({modalOpen: {...modalOpen, colorActive: false}});
                    this.updateValue(KEY_COLOR_ACTIVE, value);
                  }}
                />}
                <Tooltip
                  delay={0}
                  placement="top"
                  isOpen={this.state.tooltip.colorActive}
                  target={'key-prev-colorActive'}
                  toggle={() => this.toggleTooltip('colorActive')}
                >
                  Kolor tekstu gdy przycisk jest aktywny
                </Tooltip>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    );
  }
}

NextStatement.propTypes = {
  handlerUpdate: PropTypes.func.isRequired,
};

export default NextStatement;